import styled from 'styled-components';

export const Container = styled.div`
  background: white;
  width: 100%;
  margin-bottom: 1px;

`
export const SearchFilterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
